import type React from 'react';

import type { BrainAtlasType, MultiLang } from '../config';

import styles from './RelatedLink.module.css';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
}

const RelatedLink: React.FC<Props> = (props) => {
    const { type } = props;
    const links = {
        degu: [{ title: 'RIKEN BSI', url: 'http://www.brain.riken.jp/' }],
        jm: [{ title: 'RIKEN BSI', url: 'http://www.brain.riken.jp/' }],
        marmoset: [
            { title: 'RIKEN BSI', url: 'http://www.brain.riken.jp/' },
            {
                title: 'Keio-RIKEN Research centre for Human Cognition',
                url: 'http://human-cognition.keio.ac.jp/english/',
            },
            { title: 'FIRST project', url: 'http://www.brain.riken.jp/first-okano/en/index.html' },
            {
                title: 'Press release',
                url: 'http://www.brain.riken.jp/first-okano/en/achievements/2010/papers.html',
            },
        ],
    };
    return (
        <div className={styles.relatedLink}>
            <div className={styles.title}>
                <span>Related Link</span>
            </div>
            <ul className={styles.links}>
                {links[type].map((link) => {
                    return (
                        <li key={link.title}>
                            <a href={link.url} target="_blank" rel="noopener noreferrer">
                                {link.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default RelatedLink;
